<!-- @format -->

<div class="processing-state" *ngIf="enrolment.state === 'PROCESSING'">
  <sis-icon
    [icon]="enrolment.processingState | enrolmentProcessingStateIcon"
    aria-hidden="true"
    [color]="enrolment.processingState === 'REQ_NOT_FULFILLED' ? 'danger' : 'default'"></sis-icon>
  <span>{{ enrolment.processingState | enrolmentProcessingStateMessageKey | translate }}</span>
</div>
